import { render, staticRenderFns } from "./DigitalHumanErrorPopup.vue?vue&type=template&id=25fdec60"
import script from "./DigitalHumanErrorPopup.vue?vue&type=script&lang=ts"
export * from "./DigitalHumanErrorPopup.vue?vue&type=script&lang=ts"
import style0 from "./DigitalHumanErrorPopup.vue?vue&type=style&index=0&id=25fdec60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports